import * as React from "react";

const ExtensionCallIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M11.4458 6.72121H10.6122V4.49835C10.6122 3.88706 10.112 3.38692 9.50075 3.38692H7.2779V2.55335C7.2779 1.77535 6.66661 1.16406 5.88861 1.16406C5.11061 1.16406 4.49932 1.77535 4.49932 2.55335V3.38692H2.27647C1.66518 3.38692 1.16504 3.88706 1.16504 4.49835V6.61006H1.99861C2.83218 6.61006 3.49904 7.27692 3.49904 8.11049C3.49904 8.94406 2.83218 9.61092 1.99861 9.61092H1.16504V11.7226C1.16504 12.3339 1.66518 12.8341 2.27647 12.8341H4.38818V12.0005C4.38818 11.1669 5.05504 10.5001 5.88861 10.5001C6.72218 10.5001 7.38904 11.1669 7.38904 12.0005V12.8341H9.50075C10.112 12.8341 10.6122 12.3339 10.6122 11.7226V9.49978H11.4458C12.2238 9.49978 12.835 8.88849 12.835 8.11049C12.835 7.33249 12.2238 6.72121 11.4458 6.72121Z"
      fill="black"
      fillOpacity="0.45"
    />
  </svg>
);
export default ExtensionCallIcon;
